/**
 * 批量上传计划
 */
import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-batch-upload-campaign',
  imports: [SharedModule, BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
    ></app-batch-upload-modal>
  `,
})
export class BatchUploadCampaignComponent {
  // 输入属性
  readonly isVisible = input<boolean>(false);

  // 输出事件
  readonly isVisibleChange = output<boolean>();

  // 上传配置
  uploadConfig: BatchUploadConfig = {
    title: '批量上传计划',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量上传计划模板_2026-11-04.xlsx',
    type: 10,
    description: '1、下载批量上传计划模板，批量填写计划信息',
  };
}
